export const newMiniTool = () => ({
  value: '',
  id: Date.now().toString(),
  type: 'minitool',
  title: 'Mini Tool',
  backgroundColor: '#ECDAEC',
  color: '#800080',
});
export const newCategory = () => ({
  value: '',
  id: Date.now().toString(),
  type: 'category',
  title: 'Category',
  backgroundColor: '#FCE4D6',
  color: '#FF5C00',
});
export const newTopic = () => ({
  value: '',
  id: Date.now().toString(),
  type: 'topic',
  title: 'Topic',
  backgroundColor: '#E3F2FD',
  color: '#0C7CFF',
});
export const newSubTopic = () => ({
  value: '',
  id: Date.now().toString(),
  type: 'subTopic',
  title: 'Subtopic',
  backgroundColor: '#E0E0E0',
  color: '#333333',
});
const newContentItem = (index, type, title) => ({
  index: index,
  value: '',
  fileName: '',
  id: Date.now().toString(),
  type: type,
  title: title,
  backgroundColor: '#E2EFDA',
  color: '#00A010',
  attachTo: 'lastParent',
});

export const newParagraph = index =>
  newContentItem(index, 'paragraph', 'Paragraph');
export const newImage = index => newContentItem(index, 'img', 'Image');
export const newVideo = index => newContentItem(index, 'video', 'Video');
export const newPdf = index => newContentItem(index, 'pdf', 'PDF');

// export const newContentBetweenTopics = index =>
//   newContentItem(index, 'ContentBetweenTopics', 'Content Between Topics');
// export const newContentBetweenSubtopics = index =>
//   newContentItem(index, 'ContentBetweenSubtopics', 'Content Between Subtopics');
